
import { SET_INITIAL_TOKEN } from '../types';
import createAsyncActions from '../utilities/createAsyncActions';

export const {
  setInitialToken,
  setInitialTokenPending,
  setInitialTokenFulfilled,
  setInitialTokenRejected,
} = createAsyncActions(SET_INITIAL_TOKEN, 'setInitialToken');


// WEBPACK FOOTER //
// ./src/actions/setInitialTokenActions.js